import { FC } from 'react';

import { ReactComponent as MoonSvgAsset } from './moon.svg';

export const MoonSvg: FC<{ size: number }> = ({ size }) => <MoonSvgAsset width={size} height={size} />;
